import { useMemo, useState } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'
import type { UseFiltersPayload } from '@domain-group/react-hooks'

import { MainContent, ModalContext, TopBar } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useMainNavigation from '@hooks/useMainNavigation'

import DashboardSearch from '@components/DashboardSearch'
import LoggedInUser from '@components/LoggedInUser'
import MainNavigation from '@sections/Admin/components/MainNavigation'

import PageContent from './components/PageContent'
import { AssignTemplatePagePermissionsModalPayload } from '@modals/AssignTemplatePagePermissionsModal/AssignTemplatePagePermissionsModal'

export type PageContextPayload = UseFiltersPayload & {
  callbacks: {
    showLinkTemplatesModal: () => void,
  },
}
type BulkPermissionsModalPayload = { selectedTemplateIds: number[] }

const defaultState = {
  showLinkTemplatesModal: false,
  showBulkPermissionsModal: false
}

type SetState = (state: Partial<typeof defaultState>) => void

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showLinkTemplatesModal, showBulkPermissionsModal } = state

  const { callbacks: { toggleNavigation } } = useMainNavigation()

  const filtersPayload = useFilters({
    defaultFilters: { builder: 'canva' },
    persistFilters: true,
  })
  const {
    callbacks: filterCallbacks,
    defaultFilters,
    defaultFiltersModifiedAt,
    pageFilters,
  } = filtersPayload
  const [assignTemplatePagePermissionsPayload, setAssignTemplatePagePermissionsPayload] = useState<
      AssignTemplatePagePermissionsModalPayload | null
    >(null)
  const [showBulkPermissionsPayload, setShowBulkPermissionsPayload] = useState<
      BulkPermissionsModalPayload | null
    >(null)
  const [selectedTemplateIds, setSelectedTemplateIds] = useState<number[]>([])
  const modalContext = useModals()

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showLinkTemplatesModal: () => {
        setState({ showLinkTemplatesModal: true })
      },
      showAssignTemplatePagePermissionsModal: (payload: AssignTemplatePagePermissionsModalPayload) => {
              setAssignTemplatePagePermissionsPayload(payload)
            },
      showBulkPermissionsModal: (payload: BulkPermissionsModalPayload) => {
              setShowBulkPermissionsPayload(payload)
              setSelectedTemplateIds(payload.selectedTemplateIds)
            }
    },
    defaultFilters,
  }), [defaultFiltersModifiedAt])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <TopBar
          callbacks={{ toggleNavigation }}
          loggedInUserComponent={<LoggedInUser />}
          searchComponent={<DashboardSearch searchEntities={['LayoutTemplate', 'TaskList', 'TemplatePage', 'TemplatePagePartial']} />}
        />

        {/*
         // @ts-expect-error TS2739 */}
        <MainNavigation />

        <MainContent offset={{ top: TopBar.topBarHeight }}>
          {!showLinkTemplatesModal && <PageContent assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload!} setAssignTemplatePagePermissionsPayload= {setAssignTemplatePagePermissionsPayload} showBulkPermissionsPayload={showBulkPermissionsPayload!} setShowBulkPermissionsPayload = {setShowBulkPermissionsPayload} selectedTemplateIds={selectedTemplateIds} setSelectedTemplateIds={setSelectedTemplateIds} pageFilters={pageFilters} />}
        </MainContent>
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
